import React from 'react';
import { useQuery } from '@apollo/client';
import { Navigate } from 'react-router-dom';
import { ME } from '../../graphql/queries';

interface RouteForUsersProps {
  children: React.ReactNode;
}

const RouteForUsers: React.FC<RouteForUsersProps> = ({ children }) => {
  const { loading, error, data } = useQuery(ME);
  if (loading) return <p>Проверка прав...</p>;
  if (error || !data?.me) return <Navigate to="/no-access" />;

  const user = data.me;

  const hasAccess =
    ['user', 'admin', 'superadmin'].includes(user.role);

  if (!hasAccess) return <Navigate to="/no-access" />;

  return <>{children}</>;
};

export default RouteForUsers;